import { render, staticRenderFns } from "./AiMode.vue?vue&type=template&id=0618e5fe&scoped=true"
import script from "./AiMode.vue?vue&type=script&lang=js"
export * from "./AiMode.vue?vue&type=script&lang=js"
import style0 from "./AiMode.vue?vue&type=style&index=0&id=0618e5fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0618e5fe",
  null
  
)

export default component.exports